import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Button} from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import axios from 'axios';
import DecimalHelpBlock from './DecimalHelpBlock';
import Utils from './Utils';
import SupplierDetailsForm from './SupplierDetailsForm';
import ContractItems from './ContractItems';
import ContractDeliverables from './ContractDeliverables';
import ContractFunding from './ContractFunding';
import ContractUploads from './ContractUploads';
import AdditionalContractDetailsForm from './AdditionalContractDetailsForm';
import BudgetFields from './contracts/BudgetFields';

require('moment/locale/el');

export default class ContractDetailsForm extends Component {
    constructor() {
        super();

        this.state = {
            finalize: 0,
            competition: window.competition,

            title: "",
            budget: "",
            vat: "",
            budget_vat: "",
            hospital_protocol_number: "",
            offer_protocol_number: "",
            adam: "",
            supplier: {
                id: 0,
                company_name: "",
                representative: "",
                vat_number: "",
                tax_office_id: "",
                address: "",
                phone: "",
            },
            contract_date: moment(),
            start_date: moment(),
            end_date: moment(),
            guarantee_amount: "",
            guarantee_carrier: "",
            guarantee_expiration: moment(),
            guarantee_has_attachment: false,
            guarantee_delete_attachment: false,
            competition_type: "",
            competition_number: "",
            procurement_type: "",
            service_description: "",
            project_description: "",
            funding_source: "",
            framework_contract_id: 0,
            kae_id: 0,
            article_amounts: [],
            items: [],
            deliverables: [],

            selected_cpvs: [],

            competition_types: [],
            procurement_types: [],
            units: [],

            mg_descriptions: [],
            payment_terms: [],
            rfq_processes: [],
            co_scopes: [],
            departments: [],
            rfq_code: '',
            payment_term: null,
            rfq_process: null,
            department_id: null,
            co_scope: null,
            notes: '',
            mg_description_id: null,
            account_organization_id: null,
            savings_amount: '',
            savings_percentage: '',
        };

        this.handleSubmitDraft = this.handleSubmitDraft.bind(this);
        this.handleSubmitFinalized = this.handleSubmitFinalized.bind(this);
        this.formChange = this.formChange.bind(this);
        this.handleCompetitionTypeChange = this.handleCompetitionTypeChange.bind(this);
        this.handleProcurementTypeChange = this.handleProcurementTypeChange.bind(this);
        this.handleContractDateChange = this.handleContractDateChange.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleGuaranteeExpirationChange = this.handleGuaranteeExpirationChange.bind(this);
        this.handleCPVsChange = this.handleCPVsChange.bind(this);
        this.handleGuaranteeAmountChange = this.handleGuaranteeAmountChange.bind(this);
        this.handleGuaranteeDeleteAttachmentChange = this.handleGuaranteeDeleteAttachmentChange.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    getCPVs(input) {
        if (!input) {
            return Promise.resolve({options: []});
        }

        return axios("/contracts/ajax/cpvs/search/" + input)
            .then((response) => {
                return {options: response.data};
            });
    }

    handleCPVsChange(value, event) {
        this.setState({selected_cpvs: value});
    }

    componentWillMount() {
        let contract = window.contract;
        let items = window.items;
        let deliverables = window.deliverables;
        let units = window.units;
        let selected_cpvs = window.selected_cpvs;
        let competition_types = window.competition_types;
        let procurement_types = window.procurement_types;
        let payment_terms = window.payment_terms;
        let rfq_processes = window.rfq_processes;
        let co_scopes = window.co_scopes;
        let departments = window.departments;
        let mg_descriptions = window.mg_descriptions;
        let account_organizations = window.account_organizations;

        let contract_date = moment();
        if (contract.contract_date_formatted === null)
            contract_date = moment();
        else if (contract.contract_date_formatted === "")
            contract_date = null;
        else
            contract_date = moment(contract.contract_date_formatted, "DD/MM/YYYY");

        let start_date = moment();
        if (contract.start_date_formatted === null)
            start_date = moment();
        else if (contract.start_date_formatted === "")
            start_date = null;
        else
            start_date = moment(contract.start_date_formatted, "DD/MM/YYYY");

        let end_date = moment();
        if (contract.end_date_formatted === null)
            end_date = moment();
        else if (contract.end_date_formatted === "")
            end_date = null;
        else
            end_date = moment(contract.end_date_formatted, "DD/MM/YYYY");

        let guarantee_expiration = moment();
        if (contract.guarantee_expiration_formatted === null)
            guarantee_expiration = moment();
        else if (contract.guarantee_expiration_formatted === "")
            guarantee_expiration = null;
        else
            guarantee_expiration = moment(contract.guarantee_expiration_formatted, "DD/MM/YYYY");

        this.setState({
            contract_title: contract.contract_title,
            budget: contract.budget_comma,
            vat: contract.vat_comma,
            savings_amount: contract.savings_amount_comma,
            savings_percentage: contract.savings_percentage_comma,
            hospital_protocol_number: contract.hospital_protocol_number,
            offer_protocol_number: contract.offer_protocol_number,
            contract_adam: contract.contract_adam,
            supplier: {
                company_name: contract.supplier_company_name,
                representative: contract.supplier_representative,
                vat_number: contract.supplier_vat_number,
                tax_office_id: contract.supplier_tax_office_id,
                address: contract.supplier_address,
                phone: contract.supplier_phone,
            },
            contract_date: contract_date,
            start_date: start_date,
            end_date: end_date,
            guarantee_amount: contract.guarantee_amount_comma,
            guarantee_carrier: contract.guarantee_carrier,
            guarantee_expiration: guarantee_expiration,
            guarantee_has_attachment: !!contract.guarantee_filename,
            competition_type: contract.competition_type,
            competition_number: contract.competition_number,
            procurement_type: contract.procurement_type,
            service_description: contract.service_description,
            project_description: contract.project_description,
            funding_source: (contract.funding_source ? contract.funding_source : "resources"),
            framework_contract_id: contract.framework_contract_id,
            kae_id: contract.kae_id,
            article_amounts: window.article_amounts,
            items: items,
            deliverables: deliverables,

            selected_cpvs: selected_cpvs,

            competition_types: competition_types,
            procurement_types: procurement_types,
            units: units,

            payment_terms: payment_terms,
            rfq_processes: rfq_processes,
            co_scopes: co_scopes,
            departments: departments,
            mg_descriptions: mg_descriptions,
            account_organizations: account_organizations,
            rfq_code: contract.rfq_code || '',
            payment_term: contract.payment_term,
            rfq_process: contract.rfq_process,
            department_id: contract.department_id,
            co_scope: contract.co_scope,
            notes: contract.notes,
            mg_description_id: contract.mg_description_id,
            account_organization_id: contract.account_organization_id,
            sap_contract_number: contract.sap_contract_number,
        }, () => {
            if (this.state.budget !== undefined && this.state.budget !== "") {
                let budget = parseFloat(this.state.budget.replace(",", "."));
                this.setState({
                    budget_vat: Utils.calculateAmountVATFromAmount(this.state.vat, budget)
                });
            }
        });
    }

    handleSubmitDraft() {
        this.setState({finalize: 0}, () => {
            this.form.submit();
        });
    }

    handleSubmitFinalized() {
        this.setState({finalize: 1}, () => {
            this.form.submit();
        });
    }

    formChange(e) {
        this.onChange(e.target.name, e.target.value);
    }

    onChange(field, value) {
        this.setState({[field]: value});
    }

    handleContractDateChange(date) {
        this.setState({
            contract_date: date
        });
    }

    handleStartDateChange(date) {
        this.setState({
            start_date: date
        });
    }

    handleEndDateChange(date) {
        this.setState({
            end_date: date
        });
    }

    handleGuaranteeExpirationChange(date) {
        this.setState({
            guarantee_expiration: date
        });
    }

    handleCompetitionTypeChange(e) {
        let competition_type = "";
        if (e !== null)
            competition_type = e.value;
        this.setState({
            competition_type: competition_type
        });
    }

    handleProcurementTypeChange(e) {
        let procurement_type = "";
        if (e !== null)
            procurement_type = e.value;
        this.setState({
            procurement_type: procurement_type
        });
    }

    handleGuaranteeAmountChange(e) {
        this.setState({guarantee_amount: Utils.handleDecimals(e.target.value)});
    }

    handleGuaranteeDeleteAttachmentChange(e) {
        this.setState({guarantee_delete_attachment: e.target.checked});
    }

    render() {
        let selected_cpvs = this.state.selected_cpvs;
        let cpv_fields = [];
        for (let key in selected_cpvs) {
            if (selected_cpvs.hasOwnProperty(key)) {
                let value = selected_cpvs[key].value;
                let label = selected_cpvs[key].label;
                cpv_fields.push(
                    <div key={key}>
                        <input type="hidden" name={"selected_cpvs[" + key + "][value]"} value={value}></input>
                        <input type="hidden" name={"selected_cpvs[" + key + "][label]"} value={label}></input>
                    </div>
                )
            }
        }

        let items_component = null;
        if (this.state.procurement_type === "item") {
            items_component = <ContractItems items={this.state.items}
                                             units={this.state.units}/>;
        }

        let deliverables_component = null;
        if (['service', 'project', 'item'].indexOf(this.state.procurement_type) !== -1) {
            deliverables_component = <ContractDeliverables items={this.state.deliverables}/>;
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-right">
                            <Button onClick={this.handleSubmitDraft}
                                    bsStyle="primary">
                                <i className="fa fa-save"></i> {window.__js_contracts.temporary_save}
                            </Button>
                            &nbsp;
                            <Button onClick={this.handleSubmitFinalized}
                                    bsStyle="success">
                                <i className="fa fa-check"></i> {window.__js_contracts.final_save}
                            </Button>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className="col-md-12">
                        <form method="POST"
                              className="form-horizontal"
                              encType="multipart/form-data"
                              ref={(form) => {
                                  this.form = form;
                              }}>

                            <div className="form-group">
                                <label htmlFor="contract_title" className="control-label col-md-4">
                                    {window.__js_contracts.supply_title}*</label>
                                <div className="col-md-8">
                                    <input type="text"
                                           id="contract_title"
                                           name="contract_title"
                                           value={this.state.contract_title}
                                           className="form-control"
                                           onChange={this.formChange}/>
                                </div>
                            </div>

                            {
                                this.state.competition
                                    ? <div className="form-group">
                                        <label htmlFor="competition" className="control-label col-md-4">
                                            {window.__js_general.competition}
                                        </label>
                                        <div className="col-md-8">
                                            <div className="form-control-static">
                                                <a href={'/competitions/view/' + this.state.competition.value}
                                                   target="_blank">
                                                    {this.state.competition.label}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }

                            <BudgetFields
                                budget={this.state.budget}
                                vat={this.state.vat}
                                budgetVat={this.state.budget_vat}
                                onStateUpdate={(data) => this.setState(data)}
                            />

                            <div className="form-group">
                                <label htmlFor="hospital_protocol_number" className="control-label col-md-4">
                                    {window.__js_contracts.protocol_number}
                                </label>
                                <div className="col-md-8">
                                    <input type="text"
                                           id="hospital_protocol_number"
                                           name="hospital_protocol_number"
                                           value={this.state.hospital_protocol_number}
                                           className="form-control"
                                           onChange={this.formChange}/>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="offer_protocol_number" className="control-label col-md-4">
                                    {window.__js_contracts.offer_protocol_number}
                                </label>
                                <div className="col-md-8">
                                    <input type="text"
                                           id="offer_protocol_number"
                                           name="offer_protocol_number"
                                           value={this.state.offer_protocol_number}
                                           className="form-control"
                                           onChange={this.formChange}/>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="contract_adam"
                                       className="control-label col-md-4">{window.__js_contracts.contract_adam}</label>
                                <div className="col-md-8">
                                    <input type="text"
                                           id="contract_adam"
                                           name="contract_adam"
                                           value={this.state.contract_adam}
                                           className="form-control"
                                           onChange={this.formChange}/>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="contract_date_formatted" className="col-md-4 control-label">
                                    {window.__js_contracts.contract_date}*</label>
                                <div className="col-md-8">
                                    <DatePicker className="form-control"
                                                name="contract_date_formatted"
                                                id="contract_date_formatted"
                                                selected={this.state.contract_date}
                                                onChange={this.handleContractDateChange}
                                                dateFormat="DD/MM/YYYY"
                                                locale="el"/>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="start_date_formatted" className="col-md-4 control-label">
                                    {window.__js_contracts.start_date}*</label>
                                <div className="col-md-8">
                                    <DatePicker className="form-control"
                                                name="start_date_formatted"
                                                id="start_date_formatted"
                                                selected={this.state.start_date}
                                                onChange={this.handleStartDateChange}
                                                dateFormat="DD/MM/YYYY"
                                                locale="el"/>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="end_date_formatted" className="col-md-4 control-label">
                                    {window.__js_contracts.end_date}*</label>
                                <div className="col-md-8">
                                    <DatePicker className="form-control"
                                                name="end_date_formatted"
                                                id="end_date_formatted"
                                                selected={this.state.end_date}
                                                onChange={this.handleEndDateChange}
                                                dateFormat="DD/MM/YYYY"
                                                locale="el"/>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="guarantee_amount" className="control-label col-md-4">
                                    {window.__js_contracts.guarantee}</label>
                                <div className="col-md-8">
                                    <div className="table-responsive">
                                        <table className="table table-hover table-striped table-bordered"
                                               style={{marginBottom: 0}}>
                                            <thead>
                                            <tr>
                                                <th>{window.__js_contracts.amount}</th>
                                                <th>{window.__js_contracts.guarantee_carrier}</th>
                                                <th>{window.__js_contracts.end_date}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <input type="text"
                                                           id="guarantee_amount_comma"
                                                           name="guarantee_amount_comma"
                                                           value={this.state.guarantee_amount}
                                                           className="form-control"
                                                           onChange={this.handleGuaranteeAmountChange}/>
                                                </td>
                                                <td>
                                                    <input type="text"
                                                           id="guarantee_carrier"
                                                           name="guarantee_carrier"
                                                           value={this.state.guarantee_carrier}
                                                           className="form-control"
                                                           onChange={this.formChange}/>
                                                </td>
                                                <td>
                                                    <DatePicker className="form-control"
                                                                name="guarantee_expiration_formatted"
                                                                id="guarantee_expiration_formatted"
                                                                selected={this.state.guarantee_expiration}
                                                                onChange={this.handleGuaranteeExpirationChange}
                                                                dateFormat="DD/MM/YYYY"
                                                                locale="el"/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <DecimalHelpBlock/>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="guarantee_attachment" className="col-md-4 control-label">
                                    {window.__js_contracts.guarantee_attachment}
                                </label>
                                <div className="col-md-8">
                                    <input
                                        type="file"
                                        id="guarantee_attachment"
                                        name="guarantee_attachment"
                                        className="form-control"
                                    />

                                    {
                                        this.state.guarantee_has_attachment
                                            ? (
                                                <div>
                                                    <div>
                                                        <a href={window.contract.guarantee_attachment_url || '#'}
                                                           target="_blank">
                                                            <i className="fa fa-fw fa-cloud-download"></i>
                                                            {window.__js_contracts.download_current_file}
                                                        </a>
                                                    </div>
                                                    <div className="checkbox"
                                                         style={{paddingLeft: '20px', marginBottom: '10px'}}>
                                                        <input
                                                            type="checkbox"
                                                            id="guarantee_delete_attachment"
                                                            name="guarantee_delete_attachment"
                                                            value="1"
                                                            checked={this.state.guarantee_delete_attachment}
                                                            onChange={this.handleGuaranteeDeleteAttachmentChange}
                                                        />
                                                        <label htmlFor="guarantee_delete_attachment">
                                                            {window.__js_contracts.delete_current_file}
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                            : null
                                    }
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="cpv_ids" className="col-md-4 control-label">
                                    {window.__js_contracts.cpv_codes}
                                </label>
                                <div className="col-md-8">
                                    <Select.Async multi={true}
                                                  id="cpv_ids"
                                                  value={this.state.selected_cpvs}
                                                  onChange={this.handleCPVsChange}
                                                  loadOptions={this.getCPVs}/>

                                    {cpv_fields}
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="competition_type" className="col-md-4 control-label">
                                    {window.__js_contracts.competition_type}*</label>
                                <div className="col-md-8">
                                    <Select name="competition_type"
                                            id="competition_type"
                                            value={this.state.competition_type}
                                            options={this.state.competition_types}
                                            onChange={this.handleCompetitionTypeChange}/>
                                </div>
                            </div>

                            <div
                                className={"form-group" + (this.state.competition_type !== "apeutheias" ? "" : " hidden")}>
                                <label htmlFor="competition_number" className="control-label col-md-4">
                                    {window.__js_contracts.competition_number}</label>
                                <div className="col-md-8">
                                    <input type="text"
                                           id="competition_number"
                                           name="competition_number"
                                           value={this.state.competition_number}
                                           className="form-control"
                                           onChange={this.formChange}/>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="procurement_type" className="col-md-4 control-label">
                                    {window.__js_contracts.contract_type}*
                                </label>
                                <div className="col-md-8">
                                    <Select name="procurement_type"
                                            id="procurement_type"
                                            value={this.state.procurement_type}
                                            options={this.state.procurement_types}
                                            onChange={this.handleProcurementTypeChange}/>
                                </div>
                            </div>

                            <div
                                className={"form-group" + (this.state.procurement_type === "service" ? "" : " hidden")}>
                                <label htmlFor="service_description" className="control-label col-md-4">
                                    {window.__js_contracts.service_description}*
                                </label>
                                <div className="col-md-8">
                                    <input type="text"
                                           id="service_description"
                                           name="service_description"
                                           value={this.state.service_description}
                                           className="form-control"
                                           onChange={this.formChange}/>
                                </div>
                            </div>

                            <div
                                className={"form-group" + (this.state.procurement_type === "project" ? "" : " hidden")}>
                                <label htmlFor="project_description" className="control-label col-md-4">
                                    {window.__js_contracts.project_description}*
                                </label>
                                <div className="col-md-8">
                                    <input type="text"
                                           id="project_description"
                                           name="project_description"
                                           value={this.state.project_description}
                                           className="form-control"
                                           onChange={this.formChange}/>
                                </div>
                            </div>
                            <br/>
                            <AdditionalContractDetailsForm
                                data={this.state}
                                onChange={this.onChange}
                            />
                            <br/>
                            <SupplierDetailsForm supplier={this.state.supplier}/>
                            <br/>
                            {items_component}
                            <br/>
                            {deliverables_component}
                            <br/>
                            <ContractFunding fundingSource={this.state.funding_source}
                                             frameworkContractId={this.state.framework_contract_id}
                                             kaeId={this.state.kae_id}
                                             articleAmounts={this.state.article_amounts}/>
                            <br/>
                            <ContractUploads/>

                            <input type="hidden" name="finalize" value={this.state.finalize}/>
                            <input type="hidden" name="_token" value={this.props.csrfToken}/>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById("contract-details-form")) {
    let element = document.getElementById("contract-details-form");
    let csrf_token = element.getAttribute("data-csrf-token");
    ReactDOM.render(
        <ContractDetailsForm csrfToken={csrf_token}/>,
        element
    );
}